export const en = {
  impact_card: {
    your_volunteering: 'Your Volunteering',
    volunteering_at: 'Volunteering at',
    the_rest: 'Trending',
    hours_volunteered: 'Hours Volunteered',
    opportunities_attended: 'Events Attended',
    department_rank: 'Department Rank',
    total_hours_volunteered: 'Total Hours Volunteered',
    top_cause: 'Top Cause',
    top_nonprofit: 'Top Nonprofit',
    view_impact: '{{year}} Impact Stats',
  }
}